import { useGlobalState } from "../GlobalStates";
import { upsertNotificationAuthRequired } from "../services/notifications";

export const useUpdateWaitlist = () => {
  const [, setUser] = useGlobalState("user");

  return async (
    trip_id,
    project_id,
    notify,
    soldOut = false,
    waitlist = false
  ) => {
    // Update user state to track waitlisted items
    // If trip_id is provided, track by trip_id
    // If only project_id is provided, track by project_id
    if (trip_id) {
      setUser((u) => ({
        ...u,
        tripIdToWaitlist: {
          ...u.tripIdToWaitlist,
          [trip_id]: true,
        },
      }));
    } else if (project_id) {
      setUser((u) => ({
        ...u,
        projectIdToWaitlist: {
          ...(u.projectIdToWaitlist || {}),
          [project_id]: true,
        },
      }));
    }

    try {
      await upsertNotificationAuthRequired(
        trip_id,
        project_id,
        notify,
        soldOut,
        waitlist
      ).catch((e) => {
        console.error("Error upserting notification:", e);
      });
    } catch (e) {
      // Revert state on error
      if (trip_id) {
        setUser((u) => ({
          ...u,
          tripIdToWaitlist: {
            ...u.tripIdToWaitlist,
            [trip_id]: false,
          },
        }));
      } else if (project_id) {
        setUser((u) => ({
          ...u,
          projectIdToWaitlist: {
            ...(u.projectIdToWaitlist || {}),
            [project_id]: false,
          },
        }));
      }
    }
  };
};
